function headerHomeScroll() {
    const headerTrigger = height - 60;
    let windowY = window.scrollY;

    if (windowY > headerTrigger) { 
        homeScroll.classList.remove('header--scroll');
    } else {
        homeScroll.classList.add('header--scroll');
    }
}

function headerScrollMob() {

    const isHiddenClass = 'is-hidden';
    const isHiddenBodyClass = 'menu-hidden'

    let windowY = window.scrollY;
    
    if (windowY > scrollPos) {
        // Scrolling DOWN

        if (windowY > triggerPoint) {
            header.classList.add(isHiddenClass);
            body.classList.add(isHiddenBodyClass);
        }

    } else {
        // Scrolling UP
        header.classList.remove(isHiddenClass);
        body.classList.remove(isHiddenBodyClass);

    }

    scrollPos = windowY;

}

function darkScroll() {
    const headerTrigger = height - 60;
    let windowY = window.scrollY;

    if (windowY > headerTrigger) { 
        body.classList.remove('theme-dark');
    } else {
        body.classList.add('theme-dark');
    }
}